import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "./header.css"

const Header = ({ siteTitle }) => (
  <header
    style={{
      position: `absolute`,
      top: 0,
      width: `100%`,
      height: `var(--header-height)`,
      background: 'rgb(28, 54, 91)',
      boxShadow: `0 3px 6px rgba(0,0,0,.2)`
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        display: `flex`,
        height: `100%`,
        justifyContent: `space-between`,
        alignItems: `stretch`
      }}
    >
      <h1 style={{
        display: `flex`,
        alignItems: `center`,
        margin: 0 
      }}>
        <Link
          to="/"
          style={{
            color: `rgb(255, 255, 255)`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
      <div>
        <ul style={{
          display: `flex`,
          listStyle: `none`,
          alignItems: `stretch`,
          margin: 0,
          height: `100%`,
          lineHeight: `var(--header-height)`,
          boxSizing: `border-box`,
          textTransform: `uppercase`,
          color: `rgb(214, 214, 214)`
        }} className="nav-list">
          {/* <li>
            <Link to="/" activeClassName="active">About</Link>
          </li>
          <li>
            <Link to="/" activeClassName="active">Projects</Link>
          </li> */}
          <li>
            <Link to="/blog/" activeClassName="active" partiallyActive>Blog</Link>
          </li>
        </ul>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
